<template>
    <LayoutBase>
        <div :class="{ 'mobile_container': true, 'is-admin': isAdmin }">
            <div class="mobile_header">
                <mobile-header></mobile-header>
            </div>

            <main class="mobile_main">
                <slot></slot>
            </main>

            <div id="page-modals">
                <hash-modals></hash-modals>
                <slot name="modals"></slot>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
import MobileHeader from "./components/MobileHeader";
import localStorageService from "../../services/localStorage";
import HashModals from "../page/HashModals";
import LayoutBase from "../base/LayoutBase.vue";

export default {
  name: "LayoutMobile",
  components: {
    LayoutBase,
    HashModals,
    MobileHeader
  },
  mounted() {
    // This is here so that html, body, and #app have height set via css
    const root = document.documentElement
    root.classList.add('layout_page')
  },
  computed: {
    isAdmin() {
      return localStorageService.getAdminMode();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.mobile_container {
  position: relative;
  min-height: 100%;
  min-width: 320px;
  padding-top: $headerHeight;
  background-color: $background;

  &.is-admin {
    .mobile_header {
      background-color: transparentize($red, 0.8);
    }
  }
}

.mobile_header {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  height: $headerHeight;
  padding: 0 10px;
  background-color: $white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.mobile_main {
  padding: 10px 16px;
}
</style>
